import { ContactType } from '../types';

export const contactLabel = (type: ContactType): string => {
  switch (type) {
    case 'personal_hr': return 'recruiter';
    case 'personal_role': return 'hiring manager';
    default: return 'contact';
  }
};
